import React from 'react';

import styled from 'styled-components';

type FeatureProps = {
  color?: string;
  iconColor?: string;
  features: string[];
};

export const Wrapper = styled.div<FeatureProps>`
  border-top: 1px solid #e3e5ea;
  margin-top: 1em;
  padding-top: 1em;
  .feature {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${(props) => props.color ?? '#62656a'};
    margin-bottom: 0.3em;
    .icon {
      display: flex;
      justify-content: center;
      margin-right: 0.2em;
    }
  }
`;

export const Features: React.FC<FeatureProps> = (props) => {
  const { features, iconColor } = props;
  return (
    <Wrapper {...props}>
      {features.map((line, idx) => (
        <div className="feature" key={`${idx}`}>
          <div className="icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.08594 11.9048L9.77246 15.7964L17.0669 7.98633"
                stroke={iconColor ?? '#055CF5'}
                strokeWidth="2"
                strokeLinecap="square"
              />
            </svg>
          </div>
          <div>{line}</div>
        </div>
      ))}
    </Wrapper>
  );
};
